var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEdit(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.91306 18.8869L16.9132 10.8867L13.1133 7.08676L5.11312 15.0869C5.00298 15.1972 4.92475 15.3352 4.88671 15.4864L4 20L8.51275 19.1133C8.66426 19.0754 8.80286 18.9971 8.91306 18.8869ZM19.4959 8.30405C19.8187 7.98117 20 7.54331 20 7.08676C20 6.63021 19.8187 6.19235 19.4959 5.86947L18.1305 4.50411C17.8077 4.18133 17.3698 4 16.9132 4C16.4567 4 16.0188 4.18133 15.696 4.50411L14.3306 5.86947L18.1305 9.66941L19.4959 8.30405Z",
    fill: "#C6CCFE"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEdit);
export default __webpack_public_path__ + "static/media/edit.04b0a884d13af810520205e1862f2c91.svg";
export { ForwardRef as ReactComponent };